import React, { Component } from 'react';
import { inject } from 'mobx-react';

import { localizable } from 'components/Localization';
import dynamicImport from 'components/dynamicImport';

const RefuseDialogContent = dynamicImport({
  component: '/containers/Sale/OffersSection/RefuseDialog',
});

@inject('app')
@localizable
class RefuseDialog extends Component {
  render() {
    return <RefuseDialogContent {...this.props} />;
  }
}

export default RefuseDialog;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/RefuseDialog.jsx